/**
* Image Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'image-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.image-slider__splide' ).each( function( key, component ) {
        if ( $( component ).attr( 'data-autoscroll' ) == 'true' ) {
          new Splide( component, {
            type: 'loop',
            autoWidth: true,
            arrows: false,
            gap: '32px',
            pagination: false,
            breakpoints: {
              768: {
                autoWidth: false,
                perPage: 1,
              },
            },
            autoScroll: {
              pauseOnHover: false,
            },
          } ).mount( {AutoScroll} );
        } else {
          new Splide( component, {
            type: 'loop',
            autoWidth: true,
            arrows: true,
            gap: '32px',
            pagination: false,
            centerMode: true,
            breakpoints: {
              768: {
                autoWidth: false,
                perPage: 1,
              },
            },
          } ).mount();
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-slider', COMPONENT );
} )( app );
